import { useSuspenseQuery } from '@tanstack/react-query';
import { queryKey } from '../../../constants/queryKey';
import { searchService } from 'shared/src/api';

export const useAgeFilters = () => {
  return useSuspenseQuery({
    queryKey: queryKey.ageFilters(),
    queryFn: () => searchService.getAgeFilters(),
  });
};
